export const listTypes = {
    FixedSizeList: 'FixedSizeList',
    VariableSizeList: 'VariableSizeList',
    FixedSizeGrid: 'FixedSizeGrid',
    VariableSizeGrid: 'VariableSizeGrid'
};

export const defaultRowHeight = 50; // Default row height for the list items
